import { type FC } from 'react';
import { Text, type TextProps } from '@direct-frontend/components';
import { type OpenApiSchemaProductVariantListItem } from '#shared/api/schema';
import { format } from '#shared/lib/string';

type ProductBasePriceProps = TextProps & Pick<OpenApiSchemaProductVariantListItem, 'minimal_price' | 'price'>;

const ProductBasePrice: FC<ProductBasePriceProps> = ({ minimal_price, price, ...props }) => {
    const isMinimalPriceAbovePrice = Number(minimal_price) > Number(price);

    return (
        <Text {...props}>{isMinimalPriceAbovePrice ? format(price, 'price') : <s>{format(price, 'price')}</s>}</Text>
    );
};

export const createProductBasePriceRenderer = ({
    minimal_price,
    final_price,
    price,
}: Pick<OpenApiSchemaProductVariantListItem, 'minimal_price' | 'price' | 'final_price'>): FC<TextProps> | undefined => {
    if (price && price !== final_price) {
        return function ProductBasePriceRenderer(textProps: TextProps) {
            return <ProductBasePrice minimal_price={minimal_price} price={price} {...textProps} />;
        };
    }

    return undefined;
};
